var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Select',_vm._g(_vm._b({staticClass:"ts-select",class:{ filterable: _vm.filterable },attrs:{"popper-class":"ts-select-popper","filterable":_vm.filterable}},'Select',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }